import { useEffect, useReducer } from 'react';

const initialState = {
  score: 0,
  circleAnimationComplete: false,
  scoreAnimationComplete: false
};

const animateScoreReducer = (state, action) => {
  switch (action.type) {
    case 'ANIMATE_SCORE':
      return {
        ...state,
        score: action.payload
      };
    case 'CIRCLE_ANIMATION_COMPLETE':
      return {
        ...state,
        circleAnimationComplete: action.payload
      };
    case 'SCORE_ANIMATION_START':
      return {
        ...state,
        scoreAnimationComplete: action.payload
      };
    default:
      return state;
  }
};

const useAnimateScore = ({
  score,
  animate = false,
  circleRef,
  scoreRef
}) => {
  const [state, dispatch] = useReducer(animateScoreReducer, initialState);

  useEffect(() => {
    if (animate) {
      dispatch({ type: 'ANIMATE_SCORE', payload: score });
    }
  }, [score, animate]);

  useEffect(() => {
    if (animate) {
      const circle = circleRef.current.firstElementChild.firstElementChild;
      circle.addEventListener('transitionend', () => {
        dispatch({ type: 'CIRCLE_ANIMATION_COMPLETE', payload: true });
      });
    }
  }, [animate, circleRef]);

  useEffect(() => {
    if (animate) {
      const score = scoreRef.current;
      score.addEventListener('transitionstart', () => {
        dispatch({ type: 'SCORE_ANIMATION_START', payload: true });
      });
    }
  }, [animate, scoreRef]);

  return {
    animatedScore: state.score,
    circleAnimationComplete: state.circleAnimationComplete,
    scoreAnimationComplete: state.scoreAnimationComplete
  };
};

export default useAnimateScore;
